import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { Modal } from 'react-bootstrap'
import {
  SupportFileContent,
  SupportFileIcon,
  SupportFileMobileCard,
  SupportFileMobileContentWrap,
  SupportFileName,
  SupportFilePreviewIframe,
  SupportFileRemoveButton,
  SupportFileRemoveButtonMobile,
  SupportFileRowDesktop,
  SupportFileRowMobile,
} from './MeetingRoomSupportFileItem.styles'

interface MeetingRoomSupportFileItemProps {
  fileName: string
  fileUrl: string
  mimeType?: string
  onRemove: () => void
}

const formatFileName = (name: string): string =>
  name.length > 30 ? `${name.substring(0, 27)}...` : name

const isPdfFile = (name: string, mimeType?: string, url?: string): boolean =>
  mimeType === 'application/pdf' ||
  name.toLowerCase().endsWith('.pdf') ||
  (url ?? '').toLowerCase().includes('.pdf')

export const MeetingRoomSupportFileItem = ({
  fileName,
  fileUrl,
  mimeType,
  onRemove,
}: MeetingRoomSupportFileItemProps): JSX.Element => {
  const [showPreview, setShowPreview] = useState(false)
  const isPdf = isPdfFile(fileName, mimeType, fileUrl)

  const handleFileClick = (): void => {
    if (isPdf) {
      setShowPreview(true)
    }
  }

  const handleRemoveClick = (e: React.MouseEvent): void => {
    e.stopPropagation()
    onRemove()
  }

  const fileContent = (
    <SupportFileContent
      $clickable={isPdf}
      onClick={handleFileClick}
      onKeyDown={e => {
        if (isPdf && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault()
          setShowPreview(true)
        }
      }}
      role={isPdf ? 'button' : undefined}
      tabIndex={isPdf ? 0 : undefined}
    >
      <SupportFileIcon src="/hub/tracks/pdf-file.svg" alt="PDF" />
      <SupportFileName>{formatFileName(fileName)}</SupportFileName>
    </SupportFileContent>
  )

  return (
    <>
      <SupportFileRowDesktop>
        {fileContent}
        <SupportFileRemoveButton type="button" onClick={handleRemoveClick} aria-label="Remover arquivo">
          <FontAwesomeIcon icon={faTimes} />
        </SupportFileRemoveButton>
      </SupportFileRowDesktop>

      <SupportFileRowMobile>
        <SupportFileMobileCard>
          <SupportFileMobileContentWrap>{fileContent}</SupportFileMobileContentWrap>
          <SupportFileRemoveButtonMobile
            type="button"
            onClick={handleRemoveClick}
            aria-label="Remover arquivo"
          >
            <FontAwesomeIcon icon={faTimes} />
          </SupportFileRemoveButtonMobile>
        </SupportFileMobileCard>
      </SupportFileRowMobile>

      <Modal show={showPreview} onHide={() => setShowPreview(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{fileName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SupportFilePreviewIframe src={fileUrl} title="PDF Preview" />
        </Modal.Body>
      </Modal>
    </>
  )
}
